import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 420px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 500px;
    }
  }
`;

export const ImageTextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 320px;
  }
  .text-pairing-title {
    max-width: 280px;
  }
`;

export const BorderdCircle = styled(Flex)`
  width: 50px;
  height: 50px;
  border: 3px solid #bbb1a3;
  box-sizing: border-box;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
`;

export const StyledTextImageColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column-reverse;
  }
  ${themeMediaQuery('sm')} {
    min-width: 55rem;
  }
`;

export const StyledTextImageLeftColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    min-width: 55rem;
  }
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledTextPairFlex = styled(Flex)`
  width: 100%;
  align-items: center;
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
  height: 100%;
  max-height: 350px;
  max-width: 300px;
  min-height: 300px;
  min-width: 250px;
  object-fit: contain;
`;
